import {
  GET_SUSPENDED,
  SUSPENDED_LOADING,
  SET_SUSPENDED_ITEMS_PER_PAGE,
  CHANGE_CURRENT_SUSPENDED_PAGE,
  SEARCH_SUSPENDED,
  FILTER_SUSPENDED_FUNCTIONS,
  FILTER_SUSPENDED_ROLES,
  FILTER_SUSPENDED_STATUS,
  FILTER_SUSPENDED_RECRUITER,
  FILTER_SUSPENDED_DATE,
  SET_SUSPENDED_REASON,
  FILTER_SUSPENDED_SUSPEND_DATE,
  FILTER_SUSPENDED_BD_MANAGER,
} from "../actions/suspendedAction";

const initialState = {
  suspendedList: [],
  suspendedReason: {},
  suspendedSearchText: "",
  suspendedAppliedFunctionFilter: [],
  suspendedAppliedRolesFilter: [],
  suspendedAppliedStatusFilter: [],
  suspendedAppliedRecruiterFilter: [],
  suspendedAppliedBdManagersFilter: [],
  suspendedAppliedDateFilter: [],
  suspendedAppliedSuspendedDateFilter: [],
  suspendedTotalResults: null,
  suspendedCurrentPage: 1,
  suspendedResultsPerPage: 10,
  suspendedTotalPages: null,
  suspendedPageIds: [],
  suspendedFunctionFilter: [],
  suspendedRolesFilter: [],
  suspendedRecruiterFilter: [],
  suspendedBdManagersFilter: [],
  suspendedNotifyStatusFilter: [],
  fetchingData: true,
};

const suspendedReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUSPENDED: {
      return {
        ...state,
        suspendedList: action.payload.result.results,
        suspendedTotalResults: action.payload.result.total_results,
        suspendedTotalPages: action.payload.result.total_pages,
        suspendedPageIds: action.payload.result.page_ids,
        suspendedFunctionFilter: action.payload.filter_data.functions,
        suspendedRolesFilter: action.payload.filter_data.roles,
        suspendedRecruiterFilter: action.payload.filter_data.recruiters,
        suspendedBdManagersFilter: action.payload.filter_data.bd_managers,
        suspendedNotifyStatusFilter: action.payload.filter_data.status,
        fetchingData: false,
      };
    }
    case SET_SUSPENDED_REASON: {
      return {
        ...state,
        suspendedReason: action.payload,
      };
    }
    case CHANGE_CURRENT_SUSPENDED_PAGE: {
      return {
        ...state,
        suspendedCurrentPage: action.payload,
      };
    }
    case SET_SUSPENDED_ITEMS_PER_PAGE: {
      return {
        ...state,
        suspendedResultsPerPage: action.payload,
      };
    }
    case SEARCH_SUSPENDED: {
      return {
        ...state,
        suspendedSearchText: action.payload,
      };
    }
    case FILTER_SUSPENDED_FUNCTIONS: {
      return {
        ...state,
        suspendedAppliedFunctionFilter: action.payload,
      };
    }
    case FILTER_SUSPENDED_ROLES: {
      return {
        ...state,
        suspendedAppliedRolesFilter: action.payload,
      };
    }
    case FILTER_SUSPENDED_STATUS: {
      return {
        ...state,
        suspendedAppliedStatusFilter: action.payload,
      };
    }
    case FILTER_SUSPENDED_RECRUITER: {
      return {
        ...state,
        suspendedAppliedRecruiterFilter: action.payload,
      };
    }
    case FILTER_SUSPENDED_BD_MANAGER: {
      return {
        ...state,
        suspendedAppliedBdManagersFilter: action.payload,
      };
    }
    case FILTER_SUSPENDED_DATE: {
      return {
        ...state,
        suspendedAppliedDateFilter: action.payload,
      };
    }
    case FILTER_SUSPENDED_SUSPEND_DATE: {
      return {
        ...state,
        suspendedAppliedSuspendedDateFilter: action.payload,
      };
    }
    case SUSPENDED_LOADING: {
      return {
        ...state,
        fetchingData: true,
      };
    }
    default:
      return state;
  }
};

export default suspendedReducer;
